'use strict';

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.jQuery = $;

require('./lib/viewport'); // Voeg een class toe als element in beeld is (optioneel).

//require('foundation-sites');
require('lazyload');
//require('mmenu-js');
require('@fancyapps/fancybox');
require('slick-carousel');
require('forcefeed');

import Plyr from 'plyr'; 
var raadhuis = require('./lib/default'); // Standaard JS functions (Slick slider, mmenu, sticky nav etc.).

// If you want to pick and choose which modules to include, comment out the above and uncomment the line below, go to the file and comment :
import './lib/foundation-explicit-pieces';

$(document).ready(function() {
    // Custom jQuery code here
    lazyload();    

    $('body').removeClass('preload');

    raadhuis.forceFeed();
    raadhuis.menuButton();
    raadhuis.scrolled();
    raadhuis.slickSlider();
    raadhuis.accordion();
    raadhuis.scrollToAnchor('.scroll-to');


    // NAV

    $(".nav-slider").slick({
        // normal options...
        infinite: true,
        dots: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
    });

    // HEADER

    var media = false;
   
    
    $(window).on('scroll', function() {
      $("#player").each(function(i, element) {
        if (isElementInViewport(element)) {
          const player = new Plyr(element, {
            youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 }
          });
        }
      });
    });
    
    function isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    
   var player;
   
    $('.header-media.video').on('click', function(){
        if(!media){
            $('body').addClass('media-active');
            player = new Plyr('#player', {
              youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 }
            });
            
            media = true;
            
        }else{
          $('body').addClass('media-active');
          //player.reset();
          
        }
    });
   
    $('.close-media').on('click', function(){
        if(media){
        
            $('body').removeClass('media-active');
            player.stop();
            media = true;
            
        } else{

        }
    });

   
    $(document).foundation();
});
